import React from 'react';

import {Stack, Typography} from '@mui/material';
import {formatText} from 'presentation/utils/formatText';

import {InfoLinesProps} from './types';

export function InfoLines({title, subtitle, subtitleFirst = false}: InfoLinesProps) {
	return (
		<Stack flexDirection={subtitleFirst ? 'column-reverse' : 'column'}>
			<Typography variant="body1" fontWeight={600}>
				{formatText(title)}
			</Typography>
			<Typography variant="body2" color="text.secondary">
				{formatText(subtitle)}
			</Typography>
		</Stack>
	);
}
